import React, {
  useEffect,
  useState,
} from "react";

import axios from "axios";

import {
  FaImage,
  FaEye,
} from "react-icons/fa";

import {
  toast,
  ToastContainer,
} from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const Paymenthistory = () => {

  const [data, setData] =
    useState([]);

  const [loading, setLoading] =
    useState(true);


  const fetchPaymentHistory = async () => {

    try {

      const res = await axios.get(
        "https://api.statixtrading.in/api/pay-history"
      );

      if (res.data.success) {

        setData(res.data.data);

      } else {

        setData([]);

      }

      setLoading(false);

    } catch (err) {

      console.log(err);

      setLoading(false);

    }

  };

  useEffect(() => {

    fetchPaymentHistory();

  }, []);


  const verifyPayment = async (id) => {

    try {

      const res = await axios.put(
        `https://api.statixtrading.in/api/verify-payment/${id}`
      );

      if (res.data.success) {

        toast.success(
          "Payment Verified Successfully"
        );

   
        setData((prev) =>
          prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  pay_status: "Success",
                }
              : item
          )
        );

      }

    } catch (error) {

      console.log(error);

      toast.error(
        "Verification Failed"
      );

    }

  };

  
  const unVerifyPayment = async (id) => {

    try {

      const res = await axios.put(
        `https://api.statixtrading.in/api/unverify-payment/${id}`
      );

      if (res.data.success) {

        toast.success(
          "Payment un-verified Successfully"
        );

   
        setData((prev) =>
          prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  pay_status: "Pending",
                }
              : item
          )
        );

      }

    } catch (error) {

      console.log(error);

      toast.error(
        "Verification Failed"
      );

    }

  };

  return (
    <div style={containerStyle}>

      <ToastContainer
        position="top-center"
        autoClose={2000}
      />

      <h1 style={titleStyle}>
        Payment History
      </h1>

      <div style={cardStyle}>

        {loading ? (

          <div style={loadingStyle}>
            Loading...
          </div>

        ) : (

          <table style={tableStyle}>

            <thead>

              <tr>

                <th style={thStyle}>
                SN
                </th>

                {/* <th style={thStyle}>
                Account Holder Name
                </th> */}

                <th style={thStyle}>
                  Mobile
                </th>

                <th style={thStyle}>
                  Email
                </th>

                <th style={thStyle}>
                  Pay Mode
                </th>

                <th style={thStyle}>
                  Amount
                </th>

                <th style={thStyle}>
                  Payment Image
                </th>

                <th style={thStyle}>
                  Status
                </th>

                <th style={thStyle}>
                  Action
                </th>

                <th style={thStyle}>
                  Date
                </th>

              </tr>

            </thead>

            <tbody>

              {data.length > 0 ? (

                data.map((item,index) => (

                  <tr
                    key={item.id}
                    style={rowStyle}
                  >

                    <td style={tdStyle}>
                      {index+1}
                    </td>

                    {/* <td style={tdStyle}>
                      {item. account_holder_name ||
                        "-"}
                    </td> */}

                    <td style={tdStyle}>
                      {item.user_mobile ||
                        "-"}
                    </td>

                    <td style={tdStyle}>
                      {item.user_email ||
                        "-"}
                    </td>

                    
                    <td style={tdStyle}>

                      <span
                        style={{
                          ...payModeStyle,

                          background:
                            item.pay_mode ===
                            "Cash"

                              ? "#fef3c7"

                              : item.pay_mode ===
                                "Scan"

                              ? "#ede9fe"

                              : "#dbeafe",

                          color:
                            "#1e293b",
                        }}
                      >
                        {item.pay_mode}
                      </span>

                    </td>

            
                    <td style={tdStyle}>
                      ₹ {item.amount}
                    </td>

                
<td style={tdStyle}>

  {item.pay_img ? (

    <a
      href={`https://api.statixtrading.in/uploads/${
        item.pay_img?.startsWith("[")
          ? JSON.parse(item.pay_img)[0]
          : item.pay_img
      }`}
      target="_blank"
      rel="noreferrer"
      style={imageBtnStyle}
    >

      <FaEye />

      View

    </a>

  ) : (

    <span style={noImageStyle}>

      <FaImage />

      No Image

    </span>

  )}

</td>
                   
                    <td style={tdStyle}>

                      <span
                        style={{
                          ...statusStyle,

                          background:
                            item.pay_status?.toLowerCase() ===
                            "success"

                              ? "#dcfce7"

                              : item.pay_status?.toLowerCase() ===
                                "pending"

                              ? "#fef9c3"

                              : "#fee2e2",

                          color:
                            "#1e293b",
                        }}
                      >
                        {item.pay_status}
                      </span>

                    </td>

                    

                   
<td style={tdStyle}>

  {(item.pay_mode === "Cash" ||
    item.pay_mode === "ScanPay") ? (

    item.pay_status?.toLowerCase() !==
    "success" ? (

      <button
  style={{
    ...verifyBtnStyle,
    background:
      item.pay_status?.toLowerCase() ===
      "success"
        ? "#bbf7d0"
        : "#dcfce7",
    cursor:
      item.pay_status?.toLowerCase() ===
      "success"
        ? "not-allowed"
        : "pointer",
    opacity:
      item.pay_status?.toLowerCase() ===
      "success"
        ? 0.7
        : 1,
  }}

  onClick={() =>
    verifyPayment(item.id)
  }
>
  {item.pay_status?.toLowerCase() ===
  "success"
    ? "Verified"
    : "Verify"}
</button>

    ) : (

     
      <button 
       style={{
    ...verifyBtnStyle,
    background:
      item.pay_status?.toLowerCase() ===
      "Pending"
        ? "#e99e91"
        : "#f59888",
    cursor:
      item.pay_status?.toLowerCase() ===
      "Pending"
        ? "not-allowed"
        : "pointer",
    opacity:
      item.pay_status?.toLowerCase() ===
      "Pending"
        ? 0.7
        : 1,
  }}
      onClick={() =>
    unVerifyPayment(item.id)
  }>Unverify</button>

    )

  ) : (

    <span
      style={{
        color: "#64748b",
        fontWeight: "600",
      }}
    >
      -
    </span>

  )}

</td>

                    {/* Date */}
                    <td style={tdStyle}>

                      {item.pay_on
                        ? new Date(
                            item.pay_on
                          ).toLocaleString()
                        : "-"}

                    </td>

                  </tr>

                ))

              ) : (

                <tr>

                  <td
                    colSpan="10"
                    style={emptyStyle}
                  >
                    No Payment Found
                  </td>

                </tr>

              )}

            </tbody>

          </table>

        )}

      </div>

    </div>
  );
};

const containerStyle = {
  padding: "20px",
  background: "#f8fafc",
  minHeight: "100vh",
  fontFamily: "Arial",
  width: "100%",
  boxSizing: "border-box",
};

const titleStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "20px",
  color: "#1e293b",
  fontWeight: "700",
  fontSize: "32px",
};

const cardStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "18px",
  boxShadow:
    "0 4px 20px rgba(0,0,0,0.05)",
  overflowX: "auto",
};

const tableStyle = {
  width: "100%",
  minWidth: "1200px",
  borderCollapse: "separate",
  borderSpacing: "0 12px",
};

const thStyle = {
  padding: "14px",
  background: "#a8aeb6",
  color: "#fff",
  textAlign: "center",
  fontSize: "14px",
  whiteSpace: "nowrap",
  fontWeight: "700",
};

const rowStyle = {
  background: "#fff",
  textAlign: "center",
};

const tdStyle = {
  padding: "14px",
  fontSize: "14px",
  whiteSpace: "nowrap",
  color: "#334155",
  background: "#fff",
};

const payModeStyle = {
  padding: "7px 14px",
  borderRadius: "20px",
  fontSize: "12px",
  fontWeight: "700",
  display: "inline-block",
};

const statusStyle = {
  padding: "7px 14px",
  borderRadius: "20px",
  fontSize: "12px",
  fontWeight: "700",
  display: "inline-block",
};

const imageBtnStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  background: "#dbeafe",
  color: "#1d4ed8",
  padding: "8px 14px",
  borderRadius: "10px",
  textDecoration: "none",
  fontSize: "13px",
  fontWeight: "600",
};

const noImageStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  color: "#64748b",
  fontSize: "13px",
};

const verifyBtnStyle = {
  background: "#dcfce7",
  color: "#166534",
  border: "none",
  padding: "9px 16px",
  borderRadius: "10px",
  cursor: "pointer",
  fontWeight: "700",
};

const verifiedTextStyle = {
  color: "#16a34a",
  fontWeight: "700",
};

const loadingStyle = {
  textAlign: "center",
  padding: "30px",
  fontSize: "18px",
  color: "#334155",
};

const emptyStyle = {
  textAlign: "center",
  padding: "20px",
  fontSize: "16px",
  color: "#64748b",
};

export default Paymenthistory;